import moment from 'moment'

export const formatTime = (time) => {
  return moment(time).format('DD MMM HH:mm')
}
